import { Serializable } from "../../../tendercuts/models/base";

export class PosActiveTime implements Serializable<PosActiveTime> {
  public data: any;


  constructor() { }


  deserialize(input) {
    if (!input) {
      return this;
    }

    this.data = input.data;

    return this;
  }



}
